import React from 'react';
import { Link } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { PassengersPageId } from '../../../../app/pages/domain/constants/PageId';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';

export const BackToLandingPageLink = () => {
	const { t } = useTranslation();
	const url = useUrlForPageId(PassengersPageId.Parking);

	return (
		<Link href={url}>
			{t('web_parking_booking_confirmation_back_to_landing_page_link')}
		</Link>
	);
};
